import { render, staticRenderFns } from "./foldersMaintainerViewTree.vue?vue&type=template&id=590af7be"
import script from "./foldersMaintainerViewTree.vue?vue&type=script&lang=js"
export * from "./foldersMaintainerViewTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports